import { createSvgIcon } from '@mui/material/utils';

export const BookmarkBorderIcon = createSvgIcon(
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none">
    <path
      d="M8.38118 4.24381H23.6195C24.3261 4.24407 25.089 4.90311 25.0892 5.92545V29.1862L16.8226 24.1354L16.0003 23.6325L15.1771 24.1354L6.91145 29.1862L6.9261 5.92643V5.92545C6.92633 4.89229 7.68429 4.24381 8.38118 4.24381Z"
      stroke="currentColor"
      strokeWidth="3.15493"
    />
  </svg>,
  'Bookmark',
);
